import { sendAxiosRequest } from '../../utils/sendRequest';
import UrlBuilder from '../../url/UrlBulder';
import IUserResponse from '../../../models/responces/IUserResponse';

export interface ISignInParams {
  email: string;
  pass: string;
}

export const signIn = (params: ISignInParams) =>
  sendAxiosRequest({
    method: 'post',
    url: UrlBuilder.getURL({
      handler: 'auth',
      action: 'signin'
    }),
    data: params,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IUserResponse>;

export default signIn;
